import React from 'react';
import { Container, Row, Col, Image, Nav } from 'react-bootstrap';
import CeroBrandLogo from '../assets/CeroBrandLogo.svg';
import SocialIcons from '../assets/socialIcons.svg';

export const Footer: React.FC = () => {
  return (
    <footer style={{ backgroundColor: '#0B0B0B' }}>
      <Container
        fluid
        className="d-flex justify-content-center"
        style={{ paddingTop: 60, paddingBottom: 60 }}
      >
        <Row className="w-100 justify-content-center">
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            className="d-flex flex-column align-items-center text-center"
            style={{ gap: 40 }}
          >
            <div className="d-flex align-items-center justify-content-center" style={{ gap: 12 }}>
              <Image src={CeroBrandLogo} alt="Cero" height={36} />
              <span
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 600,
                  fontSize: 20,
                  color: '#FFFFFF',
                }}
              >
                Cero
              </span>
            </div>

            <div>
              <Image src={SocialIcons} alt="Social icons" height={24} />
            </div>

            <Nav className="justify-content-center" style={{ gap: 20 }}>
              <Nav.Link href="#" className="text-white">
                Login
              </Nav.Link>
              <Nav.Link href="#features" className="text-white">
                Features
              </Nav.Link>
              <Nav.Link href="#reviews" className="text-white">
                Reviews
              </Nav.Link>
              <Nav.Link href="#community" className="text-white">
                Join Community
              </Nav.Link>
              <Nav.Link href="#pricing" className="text-white">
                Pricing
              </Nav.Link>
              <Nav.Link href="#faqs" className="text-white">
                FAQs
              </Nav.Link>
              <Nav.Link href="#terms" className="text-white">
                Terms
              </Nav.Link>
              <Nav.Link href="#privacy" className="text-white">
                Privacy
              </Nav.Link>
            </Nav>

            <div
              style={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontSize: 14,
                lineHeight: '22px',
                color: '#FFFFFFA3',
              }}
            >
              © 2025 Cero, Reg. Tiffany Tower, Cluster W, Dubai, UAE 50001. All rights reserved.
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
